import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { deleteLocation, getLocations } from "../../../actions/locations/locations";
import LocationListComponent from "../../../components/Definition/Locations/LocationListComponent";

export default function LocationScreen() {
    const [locations, setLocation] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getLocations({page:params.toString()});
                setLoading(false);
                setLocation(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <LocationListComponent lists={locations} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید محل استقرار حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteLocation(id);
                    if (response.status === "success") {
                        toast.success("محل استقرار حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف محل استقرار");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
